import React from 'react';
import { DatePicker } from 'antd';
import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat);
dayjs.extend(utc);

type AntdDatePickerProps = React.ComponentProps<typeof DatePicker>;

const formatOptions = [
  'DD/MM/YYYY',
  'D/M/YYYY',
  'D/MM/YYYY',
  'DD/M/YYYY',
  'DD-MM-YYYY',
  'D-M-YYYY',
  'D-MM-YYYY',
  'DD-M-YYYY'
];

export type UTCNoShiftDatePickerProps = Omit<AntdDatePickerProps, 'onChange' | 'picker' | 'showTime'> & {
  onChangeUTC?: (dateUTC?: Date | null) => void;
  /** onChange gốc của AntD (tùy chọn) */
  onChange?: AntdDatePickerProps['onChange'];
};

/** Dựng Date UTC thật (serialize ra ...Z) từ parts */
export function buildUTCDateFromParts(src: Dayjs): Date {
  return new Date(
    Date.UTC(src.year(), src.month(), src.date(), src.hour(), src.minute(), src.second(), src.millisecond())
  );
}

const UTCNoShiftDatePicker: React.FC<UTCNoShiftDatePickerProps> = ({ onChangeUTC, onChange, ...rest }) => {
  const handleChange: AntdDatePickerProps['onChange'] = (value, dateString) => {
    // forward onChange gốc (nếu cần)
    onChange?.(value, dateString);

    if (!value) {
      onChangeUTC?.(null);
      return;
    }

    // Ép về đầu ngày local (00:00:00)
    const startLocal = value.startOf('day');
    const dateUTC = buildUTCDateFromParts(startLocal);

    onChangeUTC?.(dateUTC);
  };

  return <DatePicker picker='date' format={formatOptions} onChange={handleChange} inputReadOnly={false} {...rest} />;
};

export default UTCNoShiftDatePicker;
